import { render, staticRenderFns } from "./license-field.vue?vue&type=template&id=13a7d544&scoped=true"
import script from "./license-field.vue?vue&type=script&lang=js"
export * from "./license-field.vue?vue&type=script&lang=js"
import style0 from "./license-field.vue?vue&type=style&index=0&id=13a7d544&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7d544",
  null
  
)

export default component.exports